import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20sports%20celebration%20moment%20with%20golden%20confetti%20and%20soft%20stadium%20lights%2C%20victory%20and%20achievement%20theme%2C%20abstract%20warm%20crimson%20and%20gold%20gradient%20background%2C%20cinematic%20mood&width=1920&height=600&seq=kaiyun-cta-bg&orientation=landscape"
        alt="加入开运体育"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/60 to-foreground-900/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          加入开运体育，赢在每一场
        </h2>
        <p className="text-background-50/70 text-sm mb-8 max-w-xl mx-auto">
          无论您是体育爱好者还是专业分析师，开运体育都为您提供最优质的体育内容服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/saishi-yuce"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}